// src/components/ComplianceBanner.jsx
import React, { useContext } from "react";
import { MODE, MARKETING_LABEL, getTEXT } from "../config/compliance";
import "./ComplianceBanner.css";
import { LangContext } from "../lang/LangProvider";

export default function ComplianceBanner() {
  const { lang } = useContext(LangContext);

  const TEXT_CONF = getTEXT(lang);
  const message = TEXT_CONF[MODE].banner;

  return (
    <div className={`comp-banner comp-${MODE.toLowerCase()}`} role="note" aria-label={MARKETING_LABEL}>
      <span className="pill">{MARKETING_LABEL}</span>
      <span className="msg">{message}</span>
    </div>
  );
}
